import dayjs from 'dayjs';

import { EMPTY_VALUE } from './formatCurrency';

/**
 * Formata a data de um contrato financeiro em `DD/MM/YYYY`.
 *
 * @param value - Data ISO vinda do backend; `null`/`undefined`/inválida retorna
 *   {@link EMPTY_VALUE}.
 *
 * @example
 * ```ts
 * formatContractDate('2026-03-14T00:00:00Z'); // '14/03/2026'
 * formatContractDate(null);                   // '—'
 * ```
 */
export function formatContractDate(value: string | null | undefined): string {
  if (!value) return EMPTY_VALUE;
  const date = dayjs(value);
  return date.isValid() ? date.format('DD/MM/YYYY') : EMPTY_VALUE;
}
